import Vue from "vue";
import Router from "vue-router";
import Login from './components/Login.vue';
import DataNotFoundCard from './components/DataNotFoundCard.vue';
import store from './store/store.js'

Vue.use(Router);

let router = new Router({

    routes: [
        {
            path: "/",
            redirect: '/index',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/manage/",
            name: "manage",
            component: () => import("./components/DatapointsList.vue"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/index",
            name: "index",
            component: () => import("./components/CategoryCard.vue"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/coord",
            name: "coord",
            component: () => import("./components/CoordinatorCard.vue"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            component: Login,
            meta: {
                guest: true
            }
        },
        {
            path: '/404',
            component: DataNotFoundCard,
            meta: {
                guest: true
            }
        },
        {
            path: '/ChooseApp',
            component: () => import("./components/ChooseApp.vue"),
            meta: {
                requiresAuth: true
            }
        },
    ],

    linkActiveClass: "active"
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            next();
            return;
        }
        next('/login')
    } else {
        next();
    }
})

export default router 